import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import { Form, Input, notification, Select } from "antd";
import "antd/dist/antd.css";
import "assets/css/styles.css";
import titleStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle";
import buttonStyles from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";
import Button from "components/CustomButtons/Button.js";

// core components
/// test
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addNewAnnualProgramAnalysis, fetchAnnualProgramAnalysissByProgram } from "../../reduxToolkit/features/annualProgramAnalysis/annualProgramAnalysisSlice";
import { fetchProgramById } from "../../reduxToolkit/features/program/ProgramsSlice";
import ErrorModal from "./ErrorModal";













const layout = {
  labelCol: {
    span: 5,
  },
  wrapperCol: {
    span: 18,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 12,
    span: 0,
  },
};

const useTitleStyles = makeStyles(titleStyles);
const useStyles = makeStyles((theme) => ({
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
  },
}));
const useButtonStyles = makeStyles(buttonStyles);

export default function AddAnnualProgramAnalysisModal(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const buttonClasses = useButtonStyles();
  const anchorRef = React.useRef(null);

  const { Option } = Select;
  const { TextArea } = Input;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [program_id, setProgram_id] = React.useState(props.program_id);
  const [type, setType] = React.useState(props.type);

  const [strength, setStrength] = React.useState("true");
  const [priorities_for_improvement, setPriorities_for_improvement] = React.useState("");
  const [areas_for_improvement, setAreas_for_improvement] = React.useState("");
  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [handledError, setHandledError] = React.useState("");

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };
  console.log(props.program_id, "program_id");
  console.log(props.type, "type");
  let obj = {
    program_id: props.program_id,
    analysisType: props.type
  }
  useEffect(() => {
    dispatch(fetchProgramById(props.program_id));

  }, [dispatch]);
  const program = useSelector((state) => state.program.program);
  console.log(program, "program");

  const onFinish = async (values) => {
    const resultAction = await dispatch(
      addNewAnnualProgramAnalysis({
        ...values,
        program_id,
        type
      })
    );
    if (addNewAnnualProgramAnalysis.fulfilled.match(resultAction)) {
      openNotificationWithIcon("success", `Add successfully`);
      dispatch(fetchAnnualProgramAnalysissByProgram(obj));
      form.resetFields();
      handleClose();
    } else {
      if (resultAction.payload) {
        setHandledError(resultAction.payload);
        handleOpenErrorModal();
        form.resetFields();
        handleClose();
      } else {
        setHandledError(resultAction.error);
        handleOpenErrorModal();
        form.resetFields();
        handleClose();
      }
    }
  };

  function onChange(date, dateString) {
    console.log(date, dateString);
  }


  return (
    <div>
      <Button
        color="primary"
        round
        ref={anchorRef}
        aria-controls={open ? "split-button-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-label="select merge strategy"
        aria-haspopup="menu"
        onClick={(event) => {
          handleClickOpen(event);
        }}
        className={`${buttonClasses.justIcon} ${buttonClasses.round}`}
      >
        <AddIcon />
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth="true"
      //maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">
          <center>{t("Add Annual Program Analysis")}</center>
        </DialogTitle>
        <DialogContent>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Form
                {...layout}
                form={form}
                name="control-hooks"
                onFinish={onFinish}
              >
                {/* <Form.Item
                  name="type"
                  label="Type"
                  rules={[
                    {
                      required: true,
                      message: "Please input the Course field.",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Course "
                    dropdownStyle={{ zIndex: 10000 }}
                  >
                    {program && program.courses &&
                      program.courses.map((course) => (
                        <Option value={course.id}>{course.title}</Option>
                      ))}
                  </Select>
                </Form.Item> */}

                <Form.Item
                  name="strength"
                  label="Strength"
                  rules={[
                    {
                      required: false,
                      message: "Please input the strength field.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="priorities_for_improvement"
                  label="Priorities for improvement"
                  rules={[
                    {
                      required: false,
                      message: "Please input the Priorities for improvement field.",
                    },
                  ]}
                >
                  <TextArea rows={2} />
                </Form.Item>
                <Form.Item
                  name="areas_for_improvement"
                  label="Areas for improvement"
                  rules={[
                    {
                      required: false,
                      message: "Please input the Areas for improvement field.",
                    },
                  ]}
                >
                  <TextArea rows={2} />
                </Form.Item>

                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    style={{ marginRight: "20px" }}
                    color="danger"
                    onClick={handleClose}
                    htmlType="submit"
                  >
                    Cancel
                  </Button>
                  <Button type="primary" color="info" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </GridItem>
          </GridContainer>
        </DialogContent>
      </Dialog>
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </div>
  );
}
